export function getStyleSheet(deleteIfExists = false) {
  let customStylesheet: HTMLStyleElement | undefined = document.getElementById("brandingStyles") as HTMLStyleElement;

  if (deleteIfExists && customStylesheet) {
    document.head.removeChild(customStylesheet);
    customStylesheet = undefined;
  }

  if (!customStylesheet) {
    customStylesheet = document.createElement("style");
    customStylesheet.id = "brandingStyles";
    document.head.appendChild(customStylesheet);
  }

  return customStylesheet;
}
